import React from 'react'
import { Link } from 'react-router-dom'
import heroImage from '../assets/img/slider/mobil-assistance-slider-1.jpg'
import './HomeHero.css'

const HERO_CONTENT = {
  headline: "Türkiye'nin Her Noktasında, Yolun Tam Kalbindeyiz.",
  support:
    '7/24 yol yardım, çekici ve ikame araç hizmetleriyle yolculuğunuzda güvenilir çözüm ortağınızız.',
  primaryCta: { label: 'Çekici Çağır', to: '/tr/cekici-cagir' },
  transportCta: {
    label: 'Şehirler Arası Taşıma',
    to: '/tr/hizmetlerimiz/sehirler-arasi-arac-tasima',
  },
  secondaryCta: { label: '0850 255 02 03', href: 'tel:08502550203' },
  whatsappCta: {
    label: 'WhatsApp',
    href: 'https://wa.me/908502550203',
  },
}

const HomeHero = () => {
  return (
    <section className="home-hero" aria-label="Mobil Assistance ana vitrin">
      <div className="home-hero__media" aria-hidden="true">
        <img
          src={heroImage}
          alt=""
          className="home-hero__image"
          width={1920}
          height={900}
          loading="eager"
          decoding="async"
          fetchPriority="high"
        />
        <div className="home-hero__veil" />
      </div>

      <div className="home-hero__inner o-container">
        <div className="home-hero__copy">
          <h1 className="home-hero__title">{HERO_CONTENT.headline}</h1>
          <p className="home-hero__lead">{HERO_CONTENT.support}</p>
          <div className="home-hero__actions">
            <div className="home-hero__cta-main">
              <Link
                to={HERO_CONTENT.primaryCta.to}
                className="home-hero__btn home-hero__btn--primary"
              >
                <i className="fas fa-car" aria-hidden="true" />
                {HERO_CONTENT.primaryCta.label}
              </Link>
              <Link
                to={`${HERO_CONTENT.transportCta.to}?fiyat=1`}
                className="home-hero__btn home-hero__btn--transport"
              >
                <i className="fas fa-truck" aria-hidden="true" />
                {HERO_CONTENT.transportCta.label}
              </Link>
            </div>
            <div className="home-hero__cta-side" aria-label="Hızlı iletişim">
              <a
                href={HERO_CONTENT.secondaryCta.href}
                className="home-hero__chip"
                aria-label="Çağrı merkezini ara"
              >
                <i className="fas fa-phone-alt" aria-hidden="true" />
                <span>{HERO_CONTENT.secondaryCta.label}</span>
              </a>
              <a
                href={HERO_CONTENT.whatsappCta.href}
                className="home-hero__chip home-hero__chip--whatsapp"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp ile iletişime geç"
              >
                <i className="fab fa-whatsapp" aria-hidden="true" />
                <span>{HERO_CONTENT.whatsappCta.label}</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="home-hero__trust" aria-label="Hizmet özeti">
        <div className="o-container home-hero__trust-row">
          <span className="home-hero__trust-item">
            <i className="fas fa-road" aria-hidden="true" />
            7/24 Yol Yardım
          </span>
          <span className="home-hero__trust-item">
            <i className="fas fa-car" aria-hidden="true" />
            İkame Araç
          </span>
          <span className="home-hero__trust-item">
            <i className="fas fa-map-marker-alt" aria-hidden="true" />
            Şehirlerarası Taşıma
          </span>
          <span className="home-hero__trust-item">
            <i className="fas fa-headset" aria-hidden="true" />
            Çağrı Merkezi
          </span>
          <span className="home-hero__trust-item">
            <i className="fas fa-map-marker-alt" aria-hidden="true" />
            Türkiye'nin Her Noktasında
          </span>
        </div>
      </div>
    </section>
  )
}

export default HomeHero
